import * as React from 'react';
import Grid from '@mui/material/Grid';
import { Paper, styled } from '@mui/material';
import IrisiaStands from '../images/IrisiaStands.png';
import IrisiaEmotions from '../images/IrisiaEmotion.png';
import './Charactor.css';

const Item = styled(Paper)(({ theme }) => ({
  shadow: "none"
}));

export default function Charactor() {
  return (
    <React.Fragment>
      
      <Grid container spacing={2}>
        <Grid item xs={6}>
            <Item className='CharactorContentMargin'>
              <div className='IrisiaStands'>
                <img src={IrisiaStands} id="IrisiaStandsImg"/>
              </div>
            </Item>
        </Grid>
        <Grid item xs={6}>
            <Item id='CharactorRightArea'>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Item className='CharactorContentMargin'>
                    <div className='IrisiaEmotions'>
                      <img src={IrisiaEmotions} id="IrisiaEmotionsImg"/>
                    </div>
                  </Item>
                </Grid>
              </Grid>
              <br></br>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Item className='CharactorContentMargin'>
                    <div className='IrisiaMessage'>
                      <p>
                      『イリシアちゃん』はIrisia Projectデータセットのイメージキャラクターです。好物はエナジードリンクで、本人曰く健康を害さない程度に嗜んでいるそう。
「Irys」はギリシャ語で虹彩を意味しており、Irisia Projectデータセットは虹彩のように色彩豊かな感情表現を実現する音声データセットを目指しています。 イリシアちゃんの右目は感情に合わせて色が鮮やかに変わります。普段はおとなしい彼女ですが、感情豊かなイリシアちゃんの振る舞いを様々な技術や作品でご活用ください。
                      </p>  
                    </div>
                  </Item>
                </Grid>
              </Grid>
            </Item>
        </Grid>
      </Grid>
    </React.Fragment>
  );
}
